import { INITIAL_USER } from '@/utils/constants';

export default function () {
  return {
    fullName: undefined,
    email: undefined,
    auth0Error: null,
    user: { ...INITIAL_USER },
    sendingPasswordEmail: false,
    resetPasswordEmailError: undefined,
    sendingResetPassword: false,
    resetPasswordError: undefined,
    loadingUser: false,
    savingUser: false,
    userOrganisations: [],
    loadingUserOrganisations: false,
    savingUserOrganisation: false,
    ORGBranding: {}
  };
}
